module.exports = __webpack_public_path__ + "img/18 RedteaGO Global eSIM Plan.353e436e.png";